import { useRouter } from "next/router"
import { Cover } from "@components/anti/Cover"
import { Image } from "@components/anti/Image"
import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"

export default function ContactAdvertise() {
  const Router = useRouter()
  const { locale } = Router
  return (
    <section className="sc-contact-advertise">
      <Cover
        img="/img/bg/img_bg-contact-advertise-mobile.png"
        imgMd="/img/bg/img_bg-contact-advertise.png"
        imgHeight="h-500px"
        title=""
        text=""
        contentMaxWidth="unset"
      >
        <div className="wrapper-img">
          <Image
            src="/img/brand/img_brand-xxi.png"
            alt="brand"
            className="img-fluid d-md-inline d-none"
            width={142}
            height={62}
          />
          <Image
            src="/img/brand/img_brand-xxi.png"
            alt="brand"
            className="img-fluid d-md-none"
            width={90}
            height={40}
          />
        </div>
        <div className="wrapper-content">
          <p className="label">
            {translations[`contact_advertise_1_${locale}`]}
          </p>
          <p className="title">
            {translations[`contact_advertise_2_${locale}`]}
          </p>
          <div className="divide" />
          <Link
            target="_blank"
            href="mailto:marketing@21cineplex.co.id"
            className="email-text text-white mb-3"
          >
            <span className="air ai-envelope mr-2" /> marketing@21cineplex.co.id
          </Link>
          {/* <Link
            target="_blank"
            href="tel:021 21390707"
            className="phone-text text-white"
          >
            <span className="air ai-phone-alt mr-2" /> 021 21390707
          </Link> */}
        </div>
      </Cover>
    </section>
  )
}
